import { render, staticRenderFns } from "./UserNav.vue?vue&type=template&id=e405cbf2&scoped=true"
import script from "./UserNav.vue?vue&type=script&lang=js"
export * from "./UserNav.vue?vue&type=script&lang=js"
import style0 from "./UserNav.vue?vue&type=style&index=0&id=e405cbf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e405cbf2",
  null
  
)

export default component.exports